// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autoCompleteMotes {
    resize: vertical;
    width: calc(100% - 20px);
    background: transparent;
}


.listImage {
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 2px;
}
`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/auto-complete/auto-complete-mote-children/auto-complete-mote-children.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;AAC3B;;;AAGA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".autoCompleteMotes {\n    resize: vertical;\n    width: calc(100% - 20px);\n    background: transparent;\n}\n\n\n.listImage {\n    display: inline-block;\n    width: 50px;\n    height: 50px;\n    padding: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
